import { toast } from 'react-toastify';
import { convertDateToStringWithTime } from './convertToDate';

/**
 * Копирует координаты (широту и долготу) из объекта в буфер обмена.
 *
 * @param {Object} original - Исходный объект строки таблицы.
 * @param {string|null} original.lat - Широта.
 * @param {string|null} original.lon - Долгота.
 * @param {Function} t - Функция локализации для сообщений.
 */
export function copyCoordsToClipboard(original, t) {
  const { lat, lon, date } = original;

  // Составляем строку для копирования
  const text = `${lat ?? '-'} ${lon ?? '-'} (${convertDateToStringWithTime(date) ?? '-'})`;

  // Копируем в буфер обмена
  navigator.clipboard
    .writeText(text)
    .then(() => {
      toast.success(t?.copySuccess || 'Координаты скопированы в буфер обмена');
    })
    .catch(() => {
      toast.error(t?.copyError || 'Не удалось скопировать координаты');
    });
}
